<template>
  <!-- ══════════════════════════════════════════════
       SECTION 2 — Fonctionnement
  ══════════════════════════════════════════════ -->
  <section class="fonctionnement">

    <!-- En-tête texte -->
    <div class="fonctionnement__header">
      <span class="fonctionnement__eyebrow">En 3 simples étapes</span>
      <h2 class="fonctionnement__title">
        Fonctionnement
        <span class="fonctionnement__title-underline" aria-hidden="true"></span>
      </h2>
      <p class="fonctionnement__subtitle">
        Nolido vous aide à contourner les contraintes via ses<br class="br-desktop" />
        partenaires internationaux FX
      </p>
      <custom-button label="Demander une cotation" @click="handleCotation" />
    </div>

    <!-- Cards étapes -->
    <div class="fonctionnement__cards">
      <div
        v-for="step in steps"
        :key="step.number"
        class="step-card"
      >
        <span class="step-card__number">{{ step.number }}</span>
        <h3 class="step-card__title">{{ step.title }}</h3>
        <p class="step-card__desc">{{ step.desc }}</p>
        <div class="step-card__img-wrap">
          <img :src="step.img" :alt="step.title" class="step-card__img" />
        </div>
      </div>
    </div>

  </section>
</template>

<script>
import CustomButton from '@/components/CustomButton.vue'

export default {
  name: 'Fonctionnement',

  components: {
    CustomButton,
  },

  data() {
    return {
      steps: [
        {
          number: '01',
          title: 'Demande de cotation',
          desc: 'Indiquez le montant, la devise et le bénéficiaire',
          img: require('@/assets/img/Image Container.png'),
        },
        {
          number: '02',
          title: 'Validation par Nolido FX',
          desc: 'Un expert confirme la cotation et les modalités avec vous',
          img: require('@/assets/img/Image Container (1).png'),
        },
        {
          number: '03',
          title: 'Vérifications & Transfert',
          desc: 'Vous effectuez le paiement selon les instructions reçues et les fonds sont envoyés.',
          img: require('@/assets/img/Image Container (2).png'),
        },
      ],
    }
  },

  methods: {
    handleCotation() {
      this.$router.push('/devis')
    },
  },
}
</script>

<style scoped>
/* ════════════════════════════════════════════════
   TOKENS GLOBAUX
════════════════════════════════════════════════ */
.fonctionnement {
  --font:          'Sora', 'DM Sans', system-ui, sans-serif;
  --color-text:    #1a1a1a;
  --color-muted:   #6b6b6b;
  --color-border:  #e0ddd8;
  --color-accent:  #c8952b;
  --color-bg-card: #ffffff;
  --radius-card:   16px;
}

/* ════════════════════════════════════════════════
   SECTION 2 — FONCTIONNEMENT
════════════════════════════════════════════════ */
.fonctionnement {
  padding: 0 50px 80px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 48px;
}

/* ── Header ── */
.fonctionnement__header {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  text-align: center;
}

.fonctionnement__eyebrow {
  font-family: var(--font);
  font-size: 0.82rem;
  font-weight: 500;
  color: var(--color-muted);
  letter-spacing: 0.01em;
}

.fonctionnement__title {
  position: relative;
  margin: 0;
  font-family: var(--font);
  font-size: clamp(2rem, 4vw, 2.8rem);
  font-weight: 800;
  color: var(--color-text);
  line-height: 1.1;
  letter-spacing: -0.02em;
  padding-bottom: 10px;
}

/* Trait doré sous le titre */
.fonctionnement__title-underline {
  display: block;
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 60%;
  height: 3.5px;
  background: var(--color-accent);
  border-radius: 2px;
}

.fonctionnement__subtitle {
  margin: 0;
  font-family: var(--font);
  font-size: clamp(0.875rem, 1.2vw, 1rem);
  font-weight: 400;
  color: var(--color-muted);
  line-height: 1.65;
}

/* ── Cards ── */
.fonctionnement__cards {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  width: 100%;
}

.step-card {
  background: var(--color-bg-card);
  border: 1.5px solid var(--color-border);
  border-radius: var(--radius-card);
  padding: 24px 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  overflow: hidden;
  height: 100%;
}

/* Numéro */
.step-card__number {
  font-family: var(--font);
  font-size: 0.78rem;
  font-weight: 600;
  color: var(--color-muted);
  letter-spacing: 0.05em;
}

/* Titre de la carte */
.step-card__title {
  margin: 0;
  font-family: var(--font);
  font-size: 1.05rem;
  font-weight: 700;
  color: var(--color-text);
  line-height: 1.3;
}

/* Description */
.step-card__desc {
  margin: 0;
  font-family: var(--font);
  font-size: 0.83rem;
  font-weight: 400;
  color: var(--color-muted);
  line-height: 1.55;
}

/* Image dans la card */
.step-card__img-wrap {
  margin-top: 16px;
  border-radius: 10px;
  overflow: hidden;
  background: #f5f0e8;
  /* hauteur fixe pour uniformité */
  height: 180px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.step-card__img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

/* ════════════════════════════════════════════════
   RESPONSIVE — Tablet (≤ 900px)
════════════════════════════════════════════════ */
@media (max-width: 900px) {
  .fonctionnement {
    padding-left: 24px;
    padding-right: 24px;
  }

  .fonctionnement__cards {
    grid-template-columns: repeat(2, 1fr);
  }
}

/* ════════════════════════════════════════════════
   RESPONSIVE — Mobile (≤ 600px)
════════════════════════════════════════════════ */
@media (max-width: 600px) {
  .fonctionnement {
    padding-left: 16px;
    padding-right: 16px;
  }

  .fonctionnement__cards {
    grid-template-columns: 1fr;
  }

  .br-desktop {
    display: none;
  }
}
</style>
